#import "./fragments/CanvasFields.graphql"

query SharedEntity {
  entity {
    ...CanvasFields
  }
  viewerEmail
}
